<template>
  <div>
    <vs-popup title="سفارش جدید" :active.sync="orderPreviewVisible">
      <order-preview v-if="order" :order="order" :index="1"></order-preview>
    </vs-popup>

    <vs-prompt
      color="warning"
      @cancel="cancel(newOrderNotifTimerID)"
      @accept="accept"
      @close="close(newOrderNotifTimerID)"
      :is-valid="true"
      :title="notificationTitle"
      :text="notificationBody"
      accept-text="فهمیدم"
      button-cancel="false"
      :cancel-text="null"
      :active.sync="activePrompt"
    />
  </div>
</template>

<script>
import newOrderSound from "./assets/sounds/new-order.mp3";
import OrderPreview from "./components/order/OrderPreview.vue";

export default {
  components: { OrderPreview },
  name: "SocketSetup",
  data() {
    return {
      orderPreviewVisible: false,
      order: null,
      newOrderNotifTimerID: null,
      activePrompt: false,
      notificationTitle: "",
      notificationBody: "",
    };
  },
  methods: {
    close() {
      this.clearTimer();
    },
    cancel() {
      this.clearTimer();
    },
    accept() {
      this.clearTimer();

      if (window.location.hash.includes("/order/list")) {
        window.location.reload();
      } else {
        this.$router.push("/order/list");
      }
    },
    clearTimer() {
      if (this.newOrderNotifTimerID) clearInterval(this.newOrderNotifTimerID);
    },
    async playNotifSound() {
      // ReceiveNotifSound should be false only When canReceive is false.
      const receiveNotifSound = !(
        JSON.parse(localStorage.getItem("receiveNotifSound")) === false
      );
      if (!receiveNotifSound) {
        return;
      }

      try {
        const audio = new Audio(newOrderSound);
        await audio.play();
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async startNotificationTimer(notification) {
      if (notification) {
        if (this.newOrderNotifTimerID) clearInterval(this.newOrderNotifTimerID);

        await this.playNotifSound();
        this.newOrderNotifTimerID = setInterval(async () => {
          await this.playNotifSound();
        }, 30000);
      }
    },
    showNotification(notification) {
      if (notification.type.includes("StoredSilently")) {
        /**
         * Do nothing
         */
        return;
      }

      this.startNotificationTimer(notification);

      if (notification.type.includes("Stored")) {
        this.order = notification.data;
        this.orderPreviewVisible = true;
      } else {
        this.notificationTitle = notification.message;
        this.notificationBody = notification.detail;

        this.activePrompt = true;
      }
    },
    handleReceiveNotification(notification) {
      this.showNotification(notification);
    },
  },
  mounted() {
    require("./echo");
    this.$echo.notification(this.handleReceiveNotification);
  },
  watch: {
    orderPreviewVisible(value) {
      if (!value) {
        this.clearTimer();
      }
    },
  },
};
</script>
